import moment from 'moment';

let UtilsDate = {
    //Проверка номера телефона
    today: function(format = 'DD.MM.YYYY h:mm:ss') {
        return moment(new Date()).format(format);
    },

}

export default UtilsDate;